import { useFormContext } from "react-hook-form";

import { CheckboxField, ImageTile, TextInputField } from "@/components/kit";
import { CategoryFormData } from "@/schemas/category-form.schema";

interface CategoryFormProps {
  disabledFields?: Array<keyof CategoryFormData>;
}

export const CategoryForm = ({ disabledFields }: CategoryFormProps) => {
  const form = useFormContext<CategoryFormData>();
  const image = form.watch("image");
  const off = (field: keyof CategoryFormData) =>
    disabledFields?.includes(field);

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <TextInputField<CategoryFormData>
          isDisabled={off("name")}
          label="Category Name"
          name="name"
          placeholder="Pet care"
        />
        <TextInputField<CategoryFormData>
          dir="rtl"
          isDisabled={off("nameAr")}
          label="Category Name (Arabic)"
          name="nameAr"
          placeholder="مستلزمات الحيوانات"
        />
      </div>
      <TextInputField<CategoryFormData>
        isMono
        description="Auto-generated from name. Can only contain lowercase letters, numbers, and hyphens."
        isDisabled={off("id")}
        label="Category ID"
        name="id"
        placeholder="category-id"
      />
      <div className="flex items-start gap-3">
        <div className="min-w-0 flex-1">
          <TextInputField<CategoryFormData>
            isDisabled={off("image")}
            label="Image URL"
            name="image"
            placeholder="https://…"
          />
        </div>
        <div className="mt-[22px]">
          <ImageTile size="md" src={image} />
        </div>
      </div>
      <CheckboxField<CategoryFormData>
        label="Hide from end users?"
        name="isHidden"
      />
    </div>
  );
};
